
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const ZonasSection = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const zonas = [
    { name: 'Gavá', destacada: true },
    { name: 'Castelldefels', destacada: false },
    { name: 'Viladecans', destacada: false },
    { name: 'Sant Boi', destacada: false },
    { name: 'El Prat', destacada: false },
    { name: 'Begues', destacada: false },
    { name: 'Sant Climent', destacada: false },
    { name: 'Corbera', destacada: false },
    { name: 'Esplugues', destacada: false },
    { name: 'Cornellà', destacada: false },
  ];

  return (
    <section ref={sectionRef} id="zonas" className="py-12 sm:py-24 px-4 sm:px-6 lg:px-12 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 sm:gap-12 items-center">
          <div className="lg:col-span-3">
            <h2 
              className={`text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-8 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
              }`}
            >
              Desguace en <strong>Gavá</strong><br />y Toda la Comarca
            </h2>
            <p 
              className={`text-sm sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed transition-all duration-700 delay-150 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
              }`}
            >
              Operamos en <strong>Gavá</strong> y toda la comarca del <strong>Baix Llobregat</strong>. Recogemos tu vehículo donde lo necesites. Servicio de grúa gratuito incluido.
            </p>
            <div className="flex flex-wrap gap-2 sm:gap-3">
              {zonas.map((zona, index) => (
                <span
                  key={index}
                  className={`px-3 sm:px-5 py-1.5 sm:py-2.5 rounded-full text-xs sm:text-sm font-medium transition-all hover:shadow-md cursor-pointer duration-500 ${
                    zona.destacada
                      ? 'bg-emerald-600 text-white hover:bg-emerald-700'
                      : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                  } ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}`}
                  style={{ transitionDelay: isVisible ? `${300 + index * 50}ms` : '0ms' }}
                >
                  {zona.name}
                </span>
              ))}
            </div>
          </div>

          <div 
            className={`lg:col-span-2 transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
            }`}
          >
            <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg p-4 sm:p-8 border border-gray-100">
              <div className="aspect-square w-full">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47754.89384847892!2d1.9744!3d41.3051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4992f32e8e5e5%3A0x400f6a5f7a4d0!2sGav%C3%A0%2C%20Barcelona!5e0!3m2!1ses!2ses!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de Gavá - Desguace coches siniestrados y averiados"
                ></iframe>
              </div>
              <div className="mt-4 sm:mt-6 flex items-center justify-center space-x-2 text-gray-600">
                <i className="ri-map-pin-fill text-emerald-600 text-lg sm:text-xl"></i>
                <span className="font-medium text-sm sm:text-base">Gavá, Barcelona</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZonasSection;
